<template>
  <v-row
    class="mx-0 mt-2 mx-auto"
    style="max-width: 650px"
  >
    <v-list two-line>
      <v-list-item-group
        v-model="selected"
        active-class="pink--text"
      >
        <template v-for="(item, index) in items">
          <v-list-item
            :key="item.title"
            :value="item"
          >
            <template v-slot:default="{ }">
              <v-list-item-content>
                <v-list-item-title v-text="item.name" />
                <v-list-item-subtitle
                  style="color: #818181"
                  v-text="item.mobile"
                />
                <v-list-item-subtitle
                  class="text--primary"
                  style="color: #818181;font-size: 12px"
                  v-text="item.address"
                />
              </v-list-item-content>

              <v-list-item-action>
                <!--                <v-list-item-action-text v-text="item.action"></v-list-item-action-text>-->
              </v-list-item-action>
            </template>
          </v-list-item>
          <v-divider
            v-if="index < items.length - 1"
            :key="index"
          />
        </template>
        <v-list-item
          v-if="lastPage > 1 && lastPage > page"
          class="justify-center"
        >
          <div
            v-observe-visibility="{
              callback: visibilityChanged
            }"
            width="100%"
            height="40px"
            class="d-flex my-0 pa-2"
          >
            <v-progress-circular
              :size="20"
              :width="2"
              color="primary"
              indeterminate
            />
          </div>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-row>
</template>
<script>
  export default {
    data: () => ({
      items: [],
      selected: null,
      lastPage: 1,
      type: null,
      page: 1,
    }),
    watch: {
      selected (val) {
        this.$store.commit('setAccount', val)
        this.$router.go(-1)
      },
    },
    mounted () {
      this.type = this.$route.params.type
      this.getItems()
    },
    methods: {
      getItems () {
        var list = localStorage.getItem('person')
        list = JSON.parse(list)
        this.lastPage = Math.ceil(list.length / 10)
        this.items = [
          ...this.items,
          ...this.paginate(list, 10, this.page),
        ]
      },
      visibilityChanged (e) {
        this.page++
        e && this.getItems()
      },
    },
  }
</script>
